// extracted by mini-css-extract-plugin
export default {"root":"Detail_root__MSStv","left":"Detail_left__ppsKX","right":"Detail_right__kze32"};